import styled from "styled-components";

export const SimpleSelectStyle = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.1rem;
  width: 100%;
`;

export const Select = styled.select`
  padding: 0.4rem;
  font-size: 12px;
  margin-right: 5px;
  color: ${({ theme }) => theme.text};
  background-color: ${({ theme }) => theme.box};
  border: 1px solid ${({ theme }) => theme.borderLight};
  outline: none;
  border-radius: 5px;
  width: ${({ width }) => (width ? width : "100px")};

  /* margin-top: 0.6rem; */
`;

export const Option = styled.option`
  font-size: 12px;
`;
